<div class="zn-step-content-sections">
  <div class="zn-step-content-section zn-step-content-section--selected stand-division-section stand-division-section--form">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ (localizationKeyPrefix + '.Selection.Title') | abpLocalization }}</h5>
          <p>{{ (localizationKeyPrefix + '.Selection.Description') | abpLocalization }}</p>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-step-content-section-layout">
        <div>
          <div class="form-control-container">
            <label class="form-label" for="standDivisionAndFusionStandSelect">
              {{ 'Planning::Entity.Stand' | abpLocalization }}
              <span class="form-label-required">*</span>
            </label>
            <zn-single-select
              #standSelect
              id="standDivisionAndFusionStandSelect"
              [optionsLoader]="loadStands"
              [showSearch]="true"
              [localizationResource]="localizationResource"
              [placeholder]="(localizationKeyPrefix + '.Selection.Placeholder') | abpLocalization"
              [openUp]="false"
              (selectedChange)="onStandChange($event)"
            ></zn-single-select>
          </div>
        </div>
        <div class="zn-summary-item">
          <p class="title">{{ (localizationKeyPrefix + '.Fields.CurrentArea') | abpLocalization }}</p>
          <p class="subtitle">{{ formatArea(currentArea()) }}</p>
        </div>
        <div>
          <div class="form-control-container">
            <label class="form-label" for="standDivisionAndFusionNewArea">
              {{ (localizationKeyPrefix + '.Fields.NewArea') | abpLocalization }}
              <span class="form-label-required">*</span>
            </label>
            <input
              id="standDivisionAndFusionNewArea"
              class="form-control"
              type="number"
              min="0.01"
              step="0.01"
              inputmode="decimal"
              [value]="newAreaInput() ?? ''"
              [placeholder]="`${localizationResource}::EnterNumber` | abpLocalization"
              (input)="onNewAreaInput($any($event.target).value)"
            />
          </div>
        </div>
        <div>
          <lib-stand-gis
            [canFetchGisArea]="canFetchGisArea()"
            [name]="selectedStand()?.name ?? ''"
            (updatedGisArea)="onGisAreaUpdated($event)"
          ></lib-stand-gis>
        </div>
        <div class="zn-summary-item">
          <p class="title">{{ (localizationKeyPrefix + '.Fields.SectionedArea') | abpLocalization }}</p>
          <p class="subtitle">{{ formatArea(sectionedArea()) }}</p>
        </div>
        <div>
          <zn-button
            type="primary"
            size="normal"
            iconLeft="bi bi-plus"
            [label]="(localizationKeyPrefix + '.Selection.Add') | abpLocalization"
            [disabled]="addDisabled()"
            (clicked)="addStand()"
          ></zn-button>
        </div>
      </div>
    </div>
  </div>

  <div class="zn-full-height zn-step-content-section stand-division-section stand-division-section--table">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ (localizationKeyPrefix + '.Table.Title') | abpLocalization }}</h5>
          <p>{{ (localizationKeyPrefix + '.Table.Description') | abpLocalization }}</p>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-table" [class.zn-table--empty]="selectedRows().length === 0">
        <div class="zn-table-scroll">
          <table class="zn-table-element">
            <thead>
              <tr>
                <th>{{ 'Planning::Entity.Stand' | abpLocalization }}</th>
                <th>{{ (localizationKeyPrefix + '.Fields.StandArea') | abpLocalization }}</th>
                <th>{{ (localizationKeyPrefix + '.Fields.NewArea') | abpLocalization }}</th>
                <th>{{ (localizationKeyPrefix + '.Fields.SectionedArea') | abpLocalization }}</th>
              </tr>
            </thead>
            <tbody>
              @if (selectedRows().length === 0) {
                <tr>
                  <td class="zn-table-empty" colspan="4">
                    {{ (localizationKeyPrefix + '.Table.Empty') | abpLocalization }}
                  </td>
                </tr>
              }

              @for (row of selectedRows(); track row.id) {
                <tr [class.zn-row--original]="row.isOriginal">
                  <td>
                    <div class="zn-action-container">
                      <button
                        class="btn btn-tertiary btn-sm btn-delete"
                        type="button"
                        (click)="removeStand(row.id)"
                      >
                        <i class="bi bi-trash3"></i>
                      </button>
                      <span>{{ row.name }}</span>
                    </div>
                  </td>
                  <td>{{ formatArea(row.currentArea) }}</td>
                  <td>{{ formatArea(row.newArea) }}</td>
                  <td>{{ formatArea(row.sectionedArea) }}</td>
                </tr>
              }

              @if (selectedRows().length > 0) {
                <tr class="zn-resume">
                  <td>{{ (localizationKeyPrefix + '.Table.Total') | abpLocalization }}</td>
                  <td><span class="zn-total-input">{{ formatArea(totalCurrentArea()) }}</span></td>
                  <td><span class="zn-total-input">{{ formatArea(totalNewArea()) }}</span></td>
                  <td><span class="zn-total-input">{{ formatArea(totalSectionedArea()) }}</span></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

